import { logger as SentryLogger } from '@sentry/utils'
import * as Sentry from '@sentry/react'

const logger = {
  addBreadcrumb: (message: string, metadata?: Record<string, unknown>) => {
    // creates a trail of events that are automatically linked together within the same user session. When an
    // exception occurs, Sentry includes all breadcrumbs from that session in the error report, giving you a complete timeline of user actions leading up
    // to the error.

    // Breadcrumbs are stored in memory and automatically attached to error events, providing context like:
    // - User interactions (clicks, navigation)
    // - API calls and responses
    // - Console logs
    // - Custom events you add

    // This creates a chronological sequence that helps debug issues by showing what the user was doing before the error occurred
    Sentry.addBreadcrumb({
      message,
      level: 'info',
      data: metadata,
      timestamp: Date.now() / 1000,
    })
  },
  addBreadcrumbWithError: (
    message: string,
    metadata?: Record<string, unknown>
  ) => {
    Sentry.addBreadcrumb({
      message,
      level: 'error',
      data: metadata,
      timestamp: Date.now() / 1000,
    })

    // Also capture as an issue for errors
    Sentry.captureMessage(message, {
      level: 'error',
      extra: metadata,
    })
  },
  error: (message: unknown) => {
    SentryLogger.error(message)
  },
}

export { logger }
